"use client";

export default function Footer() {
  return (
    <footer className="iv-footer">
      <div className="iv-footer__inner">
        <div className="iv-footer__brand">
          <div className="iv-footer__logo iv-font-display">
            MyShaadhi<span className="iv-footer__logo-accent">Link</span>
          </div>
          <p className="iv-footer__tagline">
            Beautiful, personalized digital wedding invitations crafted with
            love and cultural care for your special day.
          </p>
        </div>

        <div>
          <h3 className="iv-footer__heading">Quick Links</h3>
          <ul className="iv-footer__links">
            <li>
              <a href="/templates" className="iv-footer__link">
                All Templates
              </a>
            </li>
            <li>
              <a href="/how-it-works" className="iv-footer__link">
                How It Works
              </a>
            </li>
            <li>
              <a href="#features" className="iv-footer__link">
                Features
              </a>
            </li>
          </ul>
        </div>

        <div>
          <h3 className="iv-footer__heading">Wedding Invitation Templates</h3>
          <ul className="iv-footer__links">
            <li>
              <a href="/templates/temple-theme" className="iv-footer__link">
                Temple Theme Wedding Invitation
              </a>
            </li>
            <li>
              <a href="/templates/south-indian" className="iv-footer__link">
                South Indian Wedding Invitation
              </a>
            </li>
            <li>
              <a href="/templates/christian-elegance" className="iv-footer__link">
                Christian Wedding Invitation
              </a>
            </li>
            <li>
              <a href="/templates/royal-premium" className="iv-footer__link">
                Indian Wedding Invitation (Royal Premium)
              </a>
            </li>
            <li>
              <a href="/templates/classic" className="iv-footer__link">
                Temple Wedding Invitation (Classic)
              </a>
            </li>
            <li>
              <a href="/templates/signature-of-love" className="iv-footer__link">
                Minimalist Modern Invitation
              </a>
            </li>
          </ul>
        </div>

        <div>
          <h3 className="iv-footer__heading">Get In Touch</h3>
          <ul className="iv-footer__links">
            <li>
              <a
                href="https://wa.me/919553143929"
                className="iv-footer__link"
                target="_blank"
                rel="noopener noreferrer"
              >
                WhatsApp
              </a>
            </li>
            <li>
              <a
                href="https://instagram.com/myshaadilink"
                className="iv-footer__link"
                target="_blank"
                rel="noopener noreferrer"
              >
                Instagram
              </a>
            </li>
            <li>
              <a
                href="mailto:hello@myshaadhilink.in"
                className="iv-footer__link"
              >
                hello@myshaadhilink.in
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="iv-footer__bottom">
        <span className="iv-footer__copyright">
          &copy; {new Date().getFullYear()} MyShaadhi Link (formerly InviteVibes). All rights reserved.
        </span>
        <div className="iv-footer__social">
          <a
            href="https://instagram.com/myshaadilink"
            className="iv-footer__social-link"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Instagram"
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
              <path d="M16 11.37A4 4 0 1112.63 8 4 4 0 0116 11.37z" />
              <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" />
            </svg>
          </a>
          <a
            href="https://wa.me/919553143929"
            className="iv-footer__social-link"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="WhatsApp"
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
              <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
            </svg>
          </a>
        </div>
      </div>
    </footer>
  );
}
